import { Fragment, useEffect, useState } from 'react';

import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';

import { baseURL } from '../../service/api';

import { SignProgress } from '../components/SignProgress';

export const HoaDon = (props) => {

	const [clientId, setClientId] = useState('');
	const [displayConvertDialog, setDisplayConvertDialog] = useState(false);
	const [name, setName] = useState('');
	const [displaySignProgress, setDisplaySignProgress] = useState(0);
	const [version, setVersion] = useState(0);

	useEffect(() => {
		setClientId('' + Date.now() + Math.random() * 1000);
	}, []);

	const downloadPdf = () => {
		window.open(`${baseURL}/iam-entry/invoices/${props.referenceNumber}/pdf`);
	}

	const downloadXml = () => {
		window.open(`${baseURL}/iam-entry/invoices/${props.referenceNumber}/xml`);
	}

	const sign = () => {
		window.location.href = `myinvoice:anonymous,${clientId},invoiceSignedByBuyer,${props.referenceNumber}`;
		setDisplaySignProgress(Date.now);
	}

	const onSignComplete = () => {
		setVersion(Date.now);
	}

	const showConvertDialog = () => {
		setDisplayConvertDialog(true);
	}

	const downloadConvertedInvoice = () => {
		if (name && name.trim()) {
			window.open(`${baseURL}/iam-entry/invoices/${props.referenceNumber}/converted?convertedName=${name}`);
			setDisplayConvertDialog(false);
		}
	}

	const handleRegisterClick = () => {
		window.open('https://skit.iamsoftware.com.vn/products/product-detail.html?slug=iam-invoice&ref=tracuuhoadoniam&partner=iam-invoice&campaign=tang-mien-phi-500-so-iam-invoice', '_blank');
		props.setDisplay(0);
	};

	return (
		<Fragment>
			{clientId && <SignProgress clientId={clientId} displaySignProgress={displaySignProgress} setDisplaySignProgress={setDisplaySignProgress} onSignComplete={onSignComplete} />}
			<Dialog header="Chuyển thành hóa đơn giấy" visible={displayConvertDialog} style={{ width: '400px' }} onHide={() => setDisplayConvertDialog(false)}>
				<form onSubmit={downloadConvertedInvoice}>
					<div className="grid mt-2">
						<div className="col-12">
							<div className="field p-fluid">
								<label htmlFor="name">Họ và tên người chuyển đổi</label>
								<InputText id="name" value={name} onChange={(e) => setName(e.target.value)} required />
							</div>
						</div>
						<div className="col-12 text-right">
							<Button label="Tải xuống" icon="pi pi-check" type="submit" className="p-button-sm mr-2" />
							<Button label="Đóng" icon="pi pi-times" type="button" onClick={() => setDisplayConvertDialog(false)} className="p-button-sm p-button-secondary" />
						</div>
					</div>
				</form>
			</Dialog>
			<Dialog header="Thông tin hóa đơn" visible={!!props.display} style={{ width: '100vw', maxWidth: '1500px', height: '95%' }} position="top" onHide={() => props.setDisplay(0)}>
				<div className="grid" style={{ height: '100%' }}>
					<div className="col-12 md:col-9" style={{ height: '100%' }}>
						{props.referenceNumber && (
							<iframe src={`${baseURL}/iam-entry/invoices/${props.referenceNumber}/pdf?v=${version}`} width="100%" height="100%" title={props.referenceNumber} style={{ border: 'none', borderRadius: '8px' }} />
						)}
					</div>
					<div className="col-12 md:col-3 flex flex-column gap-3" style={{ padding: '16px' }}>
						{/* Card 1: Thông tin hóa đơn */}
						<div className="surface-card p-4 shadow-1" style={{ backgroundColor: '#ffffff', borderRadius: '12px', border: '1px solid #e2ebf7' }}>
							<div className="flex align-items-center mb-4">
								<i className="pi pi-file text-blue-600 mr-2" style={{ fontSize: '1.25rem', color: '#1469c9' }}></i>
								<span className="font-bold text-lg text-900" style={{ color: '#173b67' }}>Thông tin hóa đơn</span>
							</div>

							<div className="flex flex-column gap-3 mb-4">
								<div className="flex justify-content-between align-items-center border-bottom-1 surface-border pb-2 text-sm">
									<span className="text-600">Số hóa đơn:</span>
									<span className="font-medium text-900">{props.headerInfo['invoiceNo']}</span>
								</div>
								<div className="flex justify-content-between align-items-center border-bottom-1 surface-border pb-2 text-sm">
									<span className="text-600">Tổng tiền thanh toán:</span>
									<span className="font-bold text-blue-600" style={{ color: '#1469c9' }}>{props.headerInfo['invoiceTotalLocaleString']}</span>
								</div>
								<div className="flex justify-content-between align-items-center border-bottom-1 surface-border pb-2 text-sm">
									<span className="text-600">Hạn thanh toán:</span>
									<span className="font-medium text-900">Không có hạn</span>
								</div>
							</div>

							<div className="flex flex-column gap-3">
								<Button label="Tải hóa đơn PDF" icon="pi pi-file-pdf" className="p-button-sm py-2.5 w-full" style={{ backgroundColor: '#1469c9', borderColor: '#1469c9' }} onClick={downloadPdf} />
								<Button label="Tải hóa đơn XML" icon="pi pi-download" className="p-button-outlined p-button-secondary p-button-sm py-2.5 w-full" onClick={downloadXml} />
								<Button label="Chuyển thành hóa đơn giấy" icon="pi pi-copy" className="p-button-outlined p-button-success p-button-sm py-2.5 w-full" onClick={showConvertDialog} />
								<Button label="Ký hóa đơn" icon="pi pi-pencil" className="p-button-outlined p-button-warning p-button-sm py-2.5 w-full" onClick={sign} />
							</div>
						</div>

						{/* Card 2: Promo Panel and Custom Animated Button */}
						<div className="surface-card p-3 shadow-1" style={{ backgroundColor: '#ffffff', borderRadius: '12px', border: '1px solid #e2ebf7', display: 'flex', flexDirection: 'column', gap: '16px' }}>
							<div style={{ borderRadius: '12px', overflow: 'hidden', width: '100%' }}>
								<img src="/assets/images/panel.png" alt="Promo Panel" style={{ width: '100%', display: 'block', height: 'auto' }} />
							</div>
							<button onClick={handleRegisterClick} className="premium-register-btn">
								<i className="pi pi-gift premium-icon-left"></i>
								<span className="premium-btn-text">ĐĂNG KÝ NHẬN NGAY</span>
								<i className="pi pi-chevron-right premium-icon-right"></i>
							</button>
						</div>
					</div>
				</div>
			</Dialog>
		</Fragment>
	);
}
